export type AgencyAdditionalMarginInput = {
  type?: 'FIXED' | 'PERCENT' | null;
  value?: number | null;
};

/** Adds the agency extra margin to a marged total (final total only, not per line). */
export const applyAgencyAdditionalMarginToTotal = (
  margedTotal: number,
  { type = 'FIXED', value }: AgencyAdditionalMarginInput,
): number => {
  if (value == null || Number.isNaN(Number(value))) return margedTotal;
  const numericValue = Number(value);
  return type === 'PERCENT'
    ? margedTotal + (margedTotal * numericValue) / 100
    : margedTotal + numericValue;
};
